import { ComponentProps, FC, useContext } from 'react'
import { DropdownPrimitives } from '.'
import { DropdownContext } from '../DropdownContext'

export const Separator: FC<ComponentProps<typeof DropdownPrimitives.Separator>> = (props) => {
  const { isDarkMode } = useContext(DropdownContext)

  return <DropdownPrimitives.Separator dark={isDarkMode} {...props} />
}
